import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ERPInput, ERPResult, GetERPsInput, Result, ResultList } from 'app/models';
import { Utility } from 'app/shared';
import { plainToClassFromExist } from 'class-transformer';

@Injectable({
  providedIn: 'root'
})
export class ErpService {

  constructor(private httpClient: HttpClient) { }

  public addERP(erpInput: ERPInput): Promise<Result> {
    return this.httpClient.post(Utility.serviceAddress + 'ERP/AddERP', erpInput, Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new Result(), result))
      .catch(result => plainToClassFromExist(new Result(), result.error));
  }

  public editERP(id: number, erpInput: ERPInput): Promise<Result> {
    return this.httpClient.put(Utility.serviceAddress + 'ERP/EditERP?id=' + id, erpInput, Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new Result(), result))
      .catch(result => plainToClassFromExist(new Result(), result.error));
  }

  public deleteERP(id: number): Promise<Result> {
    return this.httpClient.delete(Utility.serviceAddress + 'ERP/DeleteERP?id=' + id, Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new Result(), result))
      .catch(result => plainToClassFromExist(new Result(), result.error));
  }

  public getERPs(getERPsInput: GetERPsInput): Promise<ResultList<ERPResult>> {
    return this.httpClient.post(Utility.serviceAddress + 'ERP/GetERPs', getERPsInput, Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new ResultList<ERPResult>(), result))
      .catch(result => plainToClassFromExist(new ResultList<ERPResult>(), result.error));
  }
}
